export namespace RiderProfileErrorConstants {
  export const PROOFING_VALIDATION_FAILED: RegExp = /Rider proofing validation failed/;
}
